export class JwtUtil {
	static decode<T = { exp?: number }>(token: string): T {
		try {
			// Validate input is a string with proper JWT format (header.payload.signature)
			if (!token?.includes('.')) {
				return {} as T;
			}

			const base64Url = token.split('.')[1] ?? '';
			if (!base64Url) {
				return {} as T;
			}

			// Safely decode base64
			const normalizedBase64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
			const json = atob(normalizedBase64);

			// Parse JSON with validation
			return JSON.parse(json) as T;
		} catch (error) {
			// Handle atob or JSON.parse errors
			console.warn('Failed to decode JWT token:', error);

			return {} as T;
		}
	}

	static isExpired(token: string): boolean {
		const { exp } = this.decode(token);

		return !!exp && exp * 1000 < Date.now();
	}

	static msUntilExpiration(token: string): number | null {
		if (!token) {
			return null;
		}
		const { exp } = this.decode(token);
		if (!exp) {
			return null;
		}

		return exp ? exp * 1000 - Date.now() : null;
	}
}
